import api from '../utils/api';
import {
  SECURITY_DATA_FAILED,
  SECURITY_DATA_SUCCESS,
  REQUEST_SECURITY_DATA,
} from './types';

export const loadSecurity = (params) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_SECURITY_DATA });
    const { data } = await api.get(`/data/security?${params}`);
    dispatch({ type: SECURITY_DATA_SUCCESS, payload: data.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: SECURITY_DATA_FAILED });
  }
};
